<template>
  <div style="">
    <!-- main view halaman -->
    <div style="margin-top: 70px; background: none">
      <div style="padding: 0px" class="sub-view">
        <div class="table-navigation">
          <!-- list filter -->
          <div class="list-filter">
            <!-- filter cabang -->
            <div style="margin-right: 12px" class="filter-pilihan">
              <div @click="openClosePilihanCabang(true)" class="filter">
                <!-- tipe filter -->
                <p>Cabang :</p>
                <!-- value filter -->
                <span>{{
                  filterData.cabang ? filterData.cabang : "Semua"
                }}</span>
                <!-- icon filter -->
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <!-- box pilihan filter -->
              <div
                style="margin-top: 2px; display: none"
                ref="boxPilihanCabang"
                class="box-pilihan"
              >
                <p
                  v-for="cabang in listPenempatan"
                  :key="cabang"
                  @click="openClosePilihanCabang(false, cabang)"
                  style="border-top: 1px solid #ebeff2"
                >
                  {{ cabang }}
                  <svg
                    v-if="cabang === filterData.cabang"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan filter -->
            </div>

            <!-- end of filter cabang -->
            <!-- filter tanggal-->
            <div style="margin-right: 12px" class="filter-pilihan">
              <label for="date-picker" class="filter">
                <!-- tipe filter -->
                <p>Bulan :</p>
                <!-- value filter -->
                <span>{{
                  filterData.bulanStr ? filterData.bulanStr : "Semua"
                }}</span>
                <!-- icon filter -->
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <!-- input elemen -->
                <input
                  v-model="filterData.bulanStr"
                  id="date-picker"
                  class="date-control"
                  type="month"
                />
              </label>
            </div>
            <!-- end of filter tanggal -->

            <!-- filter Kategori-->
            <div class="filter-pilihan">
              <div @click="openClosePilihanFilterKategori(true)" class="filter">
                <!-- tipe filter -->
                <p>Kategori :</p>
                <!-- value filter -->
                <span>{{ filterData.kategori }}</span>
                <!-- icon filter -->
                <svg
                  width="10"
                  height="7"
                  viewBox="0 0 10 7"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.714294 1.35742L5.00001 5.64314L9.28572 1.35742"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>

              <!-- box pilihan filter -->
              <div
                style="margin-top: 2px; display: none"
                ref="boxPilihanFilterKategori"
                class="box-pilihan"
              >
                <p
                  @click="openClosePilihanFilterKategori(false, kategori.nama)"
                  :key="id"
                  v-for="(kategori, id) in mapKategoriAktivitasFilter"
                >
                  {{ kategori.nama }}
                  <svg
                    v-if="kategori === filterData.kategori"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan filter -->
            </div>
            <!-- end of filter kategori -->
          </div>
          <!-- end of list filter -->

          <!-- bagian untuk cari tambah dan download -->
          <div class="cari-tambah-download">
            <!-- box pencarian -->
            <div class="cari">
              <svg
                style="margin-right: 8px"
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4286 13.4294L10.3214 10.3223M12 6.28655C12 9.44246 9.44161 12.0008 6.2857 12.0008C3.12978 12.0008 0.571411 9.44246 0.571411 6.28655C0.571411 3.13064 3.12978 0.572266 6.2857 0.572266C9.44161 0.572266 12 3.13064 12 6.28655Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>

              <input
                v-model="filterData.pencarian"
                placeholder="Cari"
                type="text"
                name=""
                id=""
              />
            </div>
            <!-- button download -->
            <button @click="downloadData" class="download">
              <svg
                width="16"
                height="16"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.4286 9.14375V12.0009C13.4286 12.3798 13.278 12.7431 13.0101 13.011C12.7422 13.279 12.3789 13.4295 12 13.4295H1.99998C1.6211 13.4295 1.25774 13.279 0.98983 13.011C0.721921 12.7431 0.571411 12.3798 0.571411 12.0009V9.14375M3.42855 5.57227L6.99998 9.14369M6.99998 9.14369L10.5714 5.57227M6.99998 9.14369V0.572266"
                  stroke="#FCFCFC"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>

            <!-- open menu mobile -->
            <div class="open-menu-mobile">
              <!-- menu icon -->
              <svg
                @click="openCloseMenuMobile(true)"
                width="14"
                height="4"
                viewBox="0 0 14 4"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6.99993 2.71422C7.39442 2.71422 7.71422 2.39442 7.71422 1.99993C7.71422 1.60544 7.39442 1.28564 6.99993 1.28564C6.60544 1.28564 6.28564 1.60544 6.28564 1.99993C6.28564 2.39442 6.60544 2.71422 6.99993 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M11.9999 2.71422C12.3944 2.71422 12.7142 2.39442 12.7142 1.99993C12.7142 1.60544 12.3944 1.28564 11.9999 1.28564C11.6054 1.28564 11.2856 1.60544 11.2856 1.99993C11.2856 2.39442 11.6054 2.71422 11.9999 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.99993 2.71422C2.39442 2.71422 2.71422 2.39442 2.71422 1.99993C2.71422 1.60544 2.39442 1.28564 1.99993 1.28564C1.60544 1.28564 1.28564 1.60544 1.28564 1.99993C1.28564 2.39442 1.60544 2.71422 1.99993 2.71422Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <!-- end of menu icon -->
              <div
                style="display: none"
                ref="box-pilihan-menu"
                class="box-pilihan-aksi"
              >
                <!-- buka menu filter -->
                <p @click="openCloseFilterMobile(true)">
                  <svg
                    width="17"
                    height="15"
                    viewBox="0 0 17 15"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M16.2437 0.571289H1.04053L7.12179 7.32843V12.7141L10.1624 14.1427V7.32843L16.2437 0.571289Z"
                      stroke="#4E4B66"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Filter
                </p>
                <!-- melakukan downlaod -->
                <p @click="downloadData">
                  <svg
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M13.4287 9.14277V11.9999C13.4287 12.3788 13.2782 12.7422 13.0103 13.0101C12.7423 13.278 12.379 13.4285 12.0001 13.4285H2.0001C1.62122 13.4285 1.25786 13.278 0.989952 13.0101C0.722043 12.7422 0.571533 12.3788 0.571533 11.9999V9.14277M3.42868 5.57129L7.0001 9.14272M7.0001 9.14272L10.5715 5.57129M7.0001 9.14272V0.571289"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  Download
                </p>
              </div>
            </div>
            <!-- end of open menu mobile -->
          </div>
        </div>
        <!-- end of bagian untuk cari tambah dan download -->

        <!-- filter mobile -->
        <div style="bottom: -100%" ref="filter-mobile" class="backdrop">
          <div class="filter-mobile">
            <div class="filter-mobile-title">
              <h5>
                Filter <br />
                Aktivitas
              </h5>
              <!-- close filter -->
              <svg
                @click="openCloseFilterMobile(false)"
                width="10"
                height="10"
                viewBox="0 0 10 10"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.28566 0.714355L0.714233 9.28578M0.714233 0.714355L9.28566 9.28578"
                  stroke="#1A1A1A"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>

            <!-- input cabang -->
            <div class="keterangan input-keterangan">
              <div
                @click="openClosePilihanCabangMobile(true)"
                ref="keterangan-form"
                class="box-form email"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div class="input-and-title">
                  <span
                    v-if="filterData.cabang"
                    style="display: block"
                    class="input-title"
                    >Cabang</span
                  >
                  <p>
                    {{ filterData.cabang ? filterData.cabang : "Cabang" }}
                  </p>
                </div>
              </div>
              <!-- box pilihan cabang -->
              <div
                style="display: none"
                ref="boxPilihanCabangMobile"
                class="box-pilihan"
              >
                <p
                  @click="openClosePilihanCabangMobile(false, cabang)"
                  v-for="cabang in listPenempatan"
                  :key="cabang"
                >
                  {{ cabang }}
                  <svg
                    v-if="cabang === filterData.cabang"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan cabang-->
            </div>
            <!-- end of input cabang -->

            <!-- input bulan -->
            <label tabindex="0" for="date-picker-lahir" class="box-form email">
              <svg
                width="14"
                height="16"
                viewBox="0 0 14 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.85725 0.857422V3.71456M4.14296 0.857422V3.71456M0.571533 6.57171H13.4287M2.0001 2.28599H12.0001C12.7891 2.28599 13.4287 2.92559 13.4287 3.71456V13.7146C13.4287 14.5035 12.7891 15.1431 12.0001 15.1431H2.0001C1.21113 15.1431 0.571533 14.5035 0.571533 13.7146V3.71456C0.571533 2.92559 1.21113 2.28599 2.0001 2.28599Z"
                  stroke="#A0A3BD"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <div style="position: relative" class="input-and-title">
                <span v-if="filterData.bulanStr" class="input-title">
                  Bulan
                </span>
                <input
                  style="width: 200px; height: 50px"
                  id="date-picker-lahir"
                  class="date-control"
                  type="month"
                  v-model="filterData.bulanStr"
                />
                <p>
                  {{ filterData.bulanStr ? filterData.bulanStr : "Bulan" }}
                </p>
              </div>
            </label>
            <!-- end of input bulan -->

            <!-- input kategori -->
            <div class="keterangan input-keterangan">
              <div
                @click="openClosePilihanFilterKategori(true)"
                ref="keterangan-form"
                class="box-form email"
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.857178 11.5712L8.00003 15.1426L15.1429 11.5712M0.857178 7.99979L8.00003 11.5712L15.1429 7.99979M8.00003 0.856934L0.857178 4.42836L8.00003 7.99979L15.1429 4.42836L8.00003 0.856934Z"
                    stroke="#A0A3BD"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>

                <div class="input-and-title">
                  <span
                    v-if="filterData.kategori"
                    style="display: block"
                    class="input-title"
                    >Kategori</span
                  >
                  <p>
                    {{ filterData.kategori ? filterData.kategori : "Kategori" }}
                  </p>
                </div>
              </div>
              <!-- box pilihan kategori -->
              <div
                style="display: none"
                ref="boxPilihanFilterKategoriMobile"
                class="box-pilihan"
              >
                <p
                  @click="openClosePilihanFilterKategori(false, kategori.nama)"
                  :key="id"
                  v-for="(kategori, id) in mapKategoriAktivitasFilter"
                >
                  {{ kategori.nama }}
                  <svg
                    v-if="kategori.nama === filterData.kategori"
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M15.7142 5.71484L7.85707 13.572L4.28564 10.0006"
                      stroke="#00BA88"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </p>
              </div>
              <!-- end of box pilihan kategori -->
            </div>

            <!-- end of input kategori -->

            <div class="button-container">
              <button
                @click="openCloseFilterMobile(false)"
                class="yellow-button"
              >
                Terapkan
              </button>
            </div>
          </div>
        </div>
        <!-- end of filter mobile -->

        <!-- tabel -->
        <div class="box-table">
          <table>
            <!-- judul tabel  -->
            <tr>
              <th>Tanggal</th>
              <th>Kategori</th>
              <!-- <th style="width: 20%">Nama Target</th> -->
              <th>Nama Target</th>

              <th>Cabang</th>
              <th>Lampiran</th>
              <th>Status</th>
            </tr>
            <!-- start iterasi tabel -->
            <tr
              :key="index"
              v-for="(aktivitas, index) in listAktivitasFiltered"
            >
              <!-- Tanggal -->
              <td>
                <span style="color: #1d1d1d; font-weight: 700">{{
                  toDate(aktivitas.tanggalPengajuan.seconds)
                }}</span>
              </td>
              <!-- Kategori  -->
              <td>
                {{ aktivitas.kategori }}
              </td>
              <!-- Nama Target -->
              <td>
                <b>{{ aktivitas.namaTarget }}</b
                ><br />
                {{ aktivitas.email }}<br />
                {{ aktivitas.narahubung }}
              </td>
              <!-- Cabang -->
              <td>
                {{ aktivitas.cabang }}<br />
                <div>
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M10.5714 11.1431V10.0003C10.5714 9.39407 10.3306 8.81269 9.90197 8.38404C9.47332 7.95538 8.89194 7.71457 8.28573 7.71457H3.7143C3.10809 7.71457 2.52671 7.95538 2.09806 8.38404C1.6694 8.81269 1.42859 9.39407 1.42859 10.0003V11.1431M8.28573 3.14314C8.28573 4.4055 7.26238 5.42885 6.00002 5.42885C4.73765 5.42885 3.7143 4.4055 3.7143 3.14314C3.7143 1.88077 4.73765 0.857422 6.00002 0.857422C7.26238 0.857422 8.28573 1.88077 8.28573 3.14314Z"
                      stroke="#4E4B66"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  {{ aktivitas.reviewer }}
                </div>
              </td>
              <!-- Lampiran  -->
              <td class="tabel-lampiran">
                <p
                  @click="openCloseModalViewer(true, aktivitas.lampiranUrl[0])"
                >
                  <svg
                    width="14"
                    height="16"
                    viewBox="0 0 14 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M8.42862 0.857422H2.71434C2.33546 0.857422 1.97209 1.00793 1.70419 1.27584C1.43628 1.54375 1.28577 1.90711 1.28577 2.28599V13.7146C1.28577 14.0934 1.43628 14.4568 1.70419 14.7247C1.97209 14.9926 2.33546 15.1431 2.71434 15.1431H11.2858C11.6646 15.1431 12.028 14.9926 12.2959 14.7247C12.5638 14.4568 12.7143 14.0934 12.7143 13.7146V5.14314M8.42862 0.857422L12.7143 5.14314M8.42862 0.857422V5.14314H12.7143M9.85719 8.71456H4.14291M9.85719 11.5717H4.14291M5.57148 5.85742H4.14291"
                      stroke="#A0A3BD"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>

                  <span>Dokumen</span>
                </p>
              </td>

              <!-- Status action -->
              <td>
                <div @click="openCloseAction(true, index)">
                  <div
                    v-if="aktivitas.status === 'pending'"
                    class="status-rounded-pending"
                  >
                    Diproses
                  </div>
                  <div
                    v-else-if="aktivitas.status === 'accepted'"
                    class="status-rounded-accepted"
                  >
                    Diterima
                  </div>
                  <div
                    v-else-if="aktivitas.status === 'rejected'"
                    class="status-rounded-rejected"
                  >
                    Ditolak
                  </div>
                </div>
                <div
                  style="display: none"
                  ref="boxPilihanAksi"
                  class="box-pilihan-aksi"
                >
                  <p @click="openCloseAction(false, index, 'accepted')">
                    <svg
                      width="14"
                      height="10"
                      viewBox="0 0 14 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.7236 0.714844L4.36182 8.57199L0.561035 5.00056"
                        stroke="#00BA88"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Terima
                  </p>
                  <p @click="openCloseAction(false, index, 'rejected')">
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 10 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.28578 0.714844L0.714355 9.28627M0.714355 0.714844L9.28578 9.28627"
                        stroke="#EB5757"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    Tolak
                  </p>
                </div>
              </td>
            </tr>

            <!-- end iterasi tabel -->
          </table>
           <p
        v-if="!listAktivitasFiltered || listAktivitasFiltered.length === 0"
        class="empty-state-table"
      >
        Belum ada data
      </p>
        </div>
        <!-- end of tabel -->

        <!-- modal view lampiran -->
        <ModalViewer v-if="modalViewerIsOpen">
          <div style="text-align: center" class="modal-content">
            <object
              style="object-fit: cover; margin: 10px 0px"
              :data="urlLampiran"
              width="750"
              height="390"
            ></object>

            <button
              @click="openDokumen"
              style="margin-top: 10px"
              class="yellow-button"
            >
              Buka dokumen
            </button>
          </div>
          <!-- close button -->
          <svg
            @click="openCloseModalViewer(false)"
            style="margin-top: -438px; margin-left: 340px"
            class="close-button"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.8574 9.14307L9.14307 22.8574M9.14307 9.14307L22.8574 22.8574"
              stroke="#1D1D1D"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <!-- end of close button -->
        </ModalViewer>
        <!-- end of modal view lampiran -->
      </div>
      <!-- end of main view halaman -->
    </div>
  </div>
</template>

<script>
import ModalViewer from "@/components/modal/RelativeModal";
import XLSX from "xlsx";
import { mapState } from "vuex";
import * as soluhafire from "@/soluhafire";
import * as soluhaApi from "@/soluhaApi";

export default {
  components: {
    ModalViewer,
  },

  data() {
    return {
      // status modal
      modalViewerIsOpen: false,
      // filter
      filterData: {
        bulanStr: "",
        cabang: "",
        bulan: null,
        kategori: "Semua",
        pencarian: "",
      },
      // data modal view
      urlLampiran: "",
    };
  },

  methods: {
    openCloseMenuMobile(isOpen) {
      let box = this.$refs["box-pilihan-menu"];
      if (isOpen) box.style.display = "block";
      else box.style.display = "none";
    },

    openCloseFilterMobile(isOpen) {
      this.openCloseMenuMobile(false);
      let box = this.$refs["filter-mobile"];
      if (isOpen) box.style.bottom = "0px";
      else box.style.bottom = "-100%";
    },

    toDate(time) {
      return soluhaApi.epochToDate(time);
    },

    downloadData() {
      this.openCloseMenuMobile(false);
      let dataAktivitas = [];
      this.listAktivitasFiltered.forEach((aktivitas) => {
        dataAktivitas.push({
          tanggalPengajuan: this.toDate(
            parseInt(aktivitas.tanggalPengajuan.seconds)
          ),
          kategori: aktivitas.kategori,
          namaTarget: `${aktivitas.namaTarget} - ${aktivitas.email} - ${aktivitas.narahubung}`,
          cabang: this.userData.penempatan,
          status: aktivitas.status,
        });
      });
      const data = XLSX.utils.json_to_sheet(dataAktivitas);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, data, "data");
      XLSX.writeFile(wb, `data_aktivitas_${soluhafire.getDate()}.xlsx`); // TODO: use local time instead
    },

    openDokumen() {
      window.open(this.urlLampiran, "_blank");
    },

    // Start of modal open close logic
    openClosePilihanFilterKategori(isOpen, value) {
      let box = this.$refs.boxPilihanFilterKategori;
      let boxMobile = this.$refs.boxPilihanFilterKategoriMobile;
      if (isOpen) {
        box.style.display = "block";
        boxMobile.style.display = "block";
      } else {
        box.style.display = "none";
        boxMobile.style.display = "none";
        this.filterData.kategori = value;
      }
    },

    openClosePilihanCabang(open, value) {
      let box = this.$refs.boxPilihanCabang;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    openClosePilihanCabangMobile(open, value) {
      let box = this.$refs.boxPilihanCabangMobile;
      if (open) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        this.filterData.cabang = value;
      }
    },

    // modal berhasil
    openCloseModalBerhasil(isOpen) {
      if (isOpen) {
        this.modalInputIsOpen = false;
        this.modalBerhasilIsOpen = true;
      } else {
        this.modalBerhasilIsOpen = false;
      }
    },

    // View Lampiran
    openCloseModalViewer(isOpen, url) {
      if (isOpen) {
        this.urlLampiran = url;
        this.modalViewerIsOpen = true;
      } else {
        this.urlLampiran = "";
        this.modalViewerIsOpen = false;
      }
    },

    openCloseModalInput(isOpen) {
      if (isOpen) {
        this.openCloseMenuMobile(false);
        this.modalInputIsOpen = true;
      } else {
        this.modalInputIsOpen = false;
      }
    },

    openCloseAction(isOpen, index, newStatus = null) {
      let box = this.$refs.boxPilihanAksi[index];
      // tutup box action yang lain
      this.$refs["boxPilihanAksi"].forEach((refs) => {
        refs.style.display = "none";
      });
      if (isOpen) {
        box.style.display = "block";
      } else {
        box.style.display = "none";
        let curAktivitas = this.listAktivitasFiltered[index];
        soluhafire.ubahStatusAktivitas(
          curAktivitas.docId,
          this.userDocId,
          newStatus
        );
      }
    },
    // end of open close modal logic

    monthStringToDateRange(inStr) {
      let [year, month] = inStr.split("-");
      // month minus 1 cause js month is 0 indexing (0 is january)
      let dateAwal = new Date(parseInt(year), parseInt(month) - 1);

      let dateAkhir = new Date(dateAwal);
      this.addMonths(dateAkhir, 1);
      return {
        awal: dateAwal,
        akhir: dateAkhir,
      };
    },

    addMonths(date, months) {
      let d = date.getDate();
      date.setMonth(date.getMonth() + +months);
      if (date.getDate() != d) {
        date.setDate(0);
      }
      return date;
    },

    isManager() {
      return this.userData.jabatan === "manager";
    },
  },

  watch: {
    "filterData.bulanStr": {
      handler: function (newVal) {
        if (newVal && newVal.length > 0) {
          this.filterData.bulan = this.monthStringToDateRange(newVal);
        } else {
          this.filterData.bulan = null;
        }
      },
      deep: true,
    },

    "filterData.cabang": {
      handler: function (newVal) {
        soluhafire.getCeoKategoriAktivitas(newVal);
      },
    }
  },

  computed: {
    ...mapState([
      "userData",
      "userDocId",
      "listAktivitas",
      "listPenempatan",
      "mapKategoriAktivitas",
    ]),

    listAktivitasFiltered() {
      let listAktivitas = this.listAktivitas;
      let filterBulan = this.filterData.bulan;
      let filterCabang = this.filterData.cabang;
      let filterKategori = this.filterData.kategori;

      if (filterKategori === "Semua") filterKategori = "";
      if (filterCabang === "Semua") filterCabang = "";

      let filterPencarian = this.filterData.pencarian.toLowerCase();
      if (listAktivitas) {
        return listAktivitas.filter(function (aktivitas) {
          let passFlag = true;
          // Filter aktivitas bedasarkan waktu
          if (filterBulan) {
            passFlag =
              aktivitas.tanggalPengajuan.seconds >=
                filterBulan.awal.getTime() / 1000 &&
              aktivitas.tanggalPengajuan.seconds <
                filterBulan.akhir.getTime() / 1000;
          }
          if (!passFlag) return false;

          // Filter aktivitas bedasarkan kategori
          if (filterKategori && filterKategori.length > 0) {
            passFlag = aktivitas.kategori === filterKategori;
          }
          // filter berdasarkan cabang
          if (filterCabang && filterCabang.length > 0) {
            passFlag = aktivitas.cabang === filterCabang;
          }
          if (!passFlag) return false;

          // Filter aktivitas bedasarkan keyword
          // passFlag = namaTargetFlag || emailFlag || narahubungFlag
          if (filterPencarian && filterPencarian.length > 0) {
            passFlag = aktivitas.namaTarget
              .toLowerCase()
              .includes(filterPencarian);

            if (!passFlag) {
              passFlag = aktivitas.email
                .toLowerCase()
                .includes(filterPencarian);
            }

            if (!passFlag) {
              passFlag = aktivitas.narahubung
                .toLowerCase()
                .includes(filterPencarian);
            }
          }
          return passFlag;
        });
      }
      return [];
    },

    mapKategoriAktivitasFilter() {
      // tambah "Semua" dari list kategori yang bisa dipilih
      let mapKategoriAktivitasFilter = { ...this.mapKategoriAktivitas };
      mapKategoriAktivitasFilter["Semua"] = { nama: "Semua" };
      return mapKategoriAktivitasFilter;
    },
  },
};
</script>

<style scoped>
.failed-box-form {
  border-color: #eb5757;
}

.failed-box-form * {
  color: #eb5757;
  stroke: #eb5757;
}
</style>
